var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_626_19926)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.29 0.79V0H2.76V0.79H0V2.37H11.05V0.79H8.29Z",
    fill: "#444444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.58004 14.21V15H9.47004V14.21H10.26V3.95001H0.790039V14.21H1.58004ZM2.37004 5.53001H8.69004V13.42H2.37004V5.53001Z",
    fill: "#444444"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_626_19926"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.05,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrash);
export default __webpack_public_path__ + "static/media/icon_trash.a7a9704bba8ca56f03237249f6e7eb67.svg";
export { ForwardRef as ReactComponent };